import { insertMentionNode } from '#pplx/frontend/apps/ask/ask-input/ask-input-mentions/insertMentionNode.js';
import { insertPluginMentionNode } from '#pplx/frontend/apps/ask/skills/insertPluginMentionNode.js';
import { $clearActiveComputerCommandQuery } from '#pplx/frontend/components/form/lexical/plugins/ComputerCommandQueryPluginSupport.js';
import { useCallback } from 'react';
function clearActiveComputerCommandQuery(editor) {
    editor.update(() => {
        $clearActiveComputerCommandQuery();
    }, { discrete: true });
}
/** @returns A getter whose result is undefined when the editor is absent. */
export function useLegacyComputerCommandMenuEditor({ skillMentionEditorRef, }) {
    return useCallback(() => {
        const editor = skillMentionEditorRef?.current;
        if (!editor)
            return undefined;
        return {
            insertMention: (props, options) => insertMentionNode(editor, props, options),
            insertPluginMention: (plugin, options) => insertPluginMentionNode(editor, plugin, options),
            clearActiveCommandQuery: () => clearActiveComputerCommandQuery(editor),
        };
    }, [skillMentionEditorRef]);
}
//# sourceMappingURL=useLegacyComputerCommandMenuEditor.js.map